import styled from 'styled-components/macro'
import {
  border,
  color,
  compose,
  padding,
  space,
  typography,
} from 'styled-system'

export const Row = styled.div`
  display: contents;
`

export const Header = styled.div.attrs({
  className: 'grid-header',
  px: 'xs',
  py: 'xxs',
  borderBottom: '1px solid',
  borderBottomColor: 'border.neutral.light',
  fontSize: 3,
  fontWeight: 'bold',
})`
  ${compose(padding, border, color, typography)}
`

export const Column = styled.div.attrs({
  px: 'xs',
  py: 's',
  borderBottom: '1px solid',
  borderBottomColor: 'border.neutral.light',
  color: 'text.default',
  fontSize: 3,
})`
  ${compose(space, border, color, typography)}
`
